import { render, staticRenderFns } from "./TransferPanel.vue?vue&type=template&id=0557ba07&"
import script from "./TransferPanel.vue?vue&type=script&lang=js&"
export * from "./TransferPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports